import { Producer } from 'mediasoup-client/lib/types';

export function replaceTrack(p: Producer, track: MediaStreamTrack): Promise<boolean> {
	return p.rtpSender.track.id === track.id
		? Promise.resolve(false)
		: p.rtpSender.replaceTrack(track).then(() => true);
}
